export default __webpack_public_path__ + "static/crossImage-3947eaeeaf709a327c743f7360fdee1c.png";